import { AxiosResponse } from "axios";
import { BaseCompany } from "./bases/base.service";

export default class CompanyService {}
